import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { label: "Le programme", href: "#program" },
  { label: "Inclus", href: "#included" },
  { label: "Tarifs", href: "#pricing" },
  { label: "Avis", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
];

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.33, 1, 0.68, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "border-b border-white/5 bg-[#0a0e1a]/80 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5"
        >
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full rounded-full bg-[#c9a84c] opacity-60 breathe" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#e8c97a]" />
          </span>
          <span className="text-sm font-semibold uppercase tracking-[0.32em] text-white">
            Nuit&nbsp;Calme
          </span>
        </button>

        <div className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={() => scrollTo(l.href)}
              className="text-sm text-white/60 transition-colors duration-300 hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          data-testid="nav-cta"
          onClick={() => scrollTo("#pricing")}
          className="hidden rounded-full border border-white/15 px-5 py-2 text-sm text-white transition-colors duration-300 hover:border-[#c9a84c]/60 hover:bg-white/5 md:block"
        >
          Découvrir
        </button>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="flex flex-col gap-1.5 md:hidden"
          aria-label="Menu"
        >
          <span className="h-px w-6 bg-white" />
          <span className="h-px w-6 bg-white" />
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="overflow-hidden border-t border-white/5 bg-[#0a0e1a]/95 backdrop-blur-xl md:hidden"
          >
            <div className="flex flex-col gap-1 px-6 py-4">
              {links.map((l) => (
                <button
                  key={l.href}
                  data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                  onClick={() => {
                    scrollTo(l.href);
                    setOpen(false);
                  }}
                  className="py-2 text-left text-base text-white/70"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
